// Authenticated preview utility for layouts
// Uses the authenticated API endpoint instead of public preview

import { signageDomain } from '../app/util/domain.js';

/**
 * Opens an authenticated layout preview in a new window
 * @param {string|number} layoutId - The layout ID to preview
 * @param {Object} options - Preview options
 */
export const openAuthenticatedLayoutPreview = (layoutId, options = {}) => {
    const {
        width = 1920,
        height = 1080,
        title = 'Layout Preview'
    } = options;

    // Create a new window with the authenticated preview URL
    const previewUrl = `${signageDomain}/api/layouts/preview/${layoutId}`;

    const windowFeatures = [
        `width=${width}`,
        `height=${height}`,
        'toolbar=no',
        'location=no',
        'directories=no',
        'status=no',
        'menubar=no',
        'scrollbars=yes',
        'resizable=yes',
        'copyhistory=no'
    ].join(',');

    const previewWindow = window.open(previewUrl, title, windowFeatures);

    if (!previewWindow) {
        alert('Preview window blocked by popup blocker. Please allow popups for this site.');
        return null;
    }

    // Focus the new window
    previewWindow.focus();

    return previewWindow;
};

/**
 * Opens layout preview in fullscreen mode (for TV simulation)
 * @param {string|number} layoutId - The layout ID to preview
 */
export const openFullscreenPreview = (layoutId) => {
    return openAuthenticatedLayoutPreview(layoutId, {
        width: window.screen.width,
        height: window.screen.height,
        title: 'Layout Preview - Fullscreen'
    });
};

/**
 * Gets the authenticated preview URL for a layout
 * @param {string|number} layoutId - The layout ID
 * @returns {string} The preview URL
 */
export const getPreviewUrl = (layoutId) => {
    return `${signageDomain}/api/layouts/preview/${layoutId}`;
};

const previewUtils = {
    openAuthenticatedLayoutPreview,
    openFullscreenPreview,
    getPreviewUrl
};

export default previewUtils;